export const getBodyScrollTop = () => {
  return document.body.scrollTop || document.documentElement.scrollTop;
};